import { create } from "zustand";

interface UploadItem {
  file: File;
  preview: string;     // URL.createObjectURL
  progress: number;
  uploadedUrl?: string; // S3 URL returned after upload
}

interface UploadStore {
  images: UploadItem[];
  addImages: (files: File[]) => void;
  removeImage: (index: number) => void;
  updateProgress: (index: number, p: number) => void;
  reset: () => void;
}

export const useUploadImageStore = create<UploadStore>((set) => ({
    images: [],
    addImages: (files) => set((state) => ({
        images: [
            ...state.images,
            ...files.map((f) => ({
                file: f,
                preview: URL.createObjectURL(f),
                progress: 0,
            })),
      ],
    })),
    removeImage: (i) => set((state) => {
        const image = state.images[i];
        if (image) {
            URL.revokeObjectURL(image.preview);
        }
        return {
            images: state.images.filter((_, idx) => idx !== i),
        };
    }),
    updateProgress: (i, p) => set((state) => {
        const arr = [...state.images];
        arr[i].progress = p;
        return { images: arr };
    }),
    reset: () => set((state) => {
        state.images.forEach(image => URL.revokeObjectURL(image.preview));
        return { images: [] };
    }),
}));
